import axios from "axios";
import { BASE_URL } from "../config.json";
export const getUserCourses = (token) => {
  return axios
    .get(`${BASE_URL}/club/course/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getClubProfile = (token) => {
  return axios
    .get(`${BASE_URL}/club/club_profile/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getIncidentsByCoursesId = (token, course_id, searchKey = "") => {
  return axios
    .get(
      `${BASE_URL}/club/incident/?page=1&course_id=${course_id}&qty=500&query=${searchKey}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getHoleTimesByCoursesId = (token, course_id) => {
  return axios
    .get(`${BASE_URL}/club/course/${course_id}/times`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const saveCourseHolesTimes = (token, course_id, hole_list) => {
  return axios
    .put(`${BASE_URL}/club/course/${course_id}/times`, hole_list, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const saveClubProfileDetails = (token, clubDetails) => {
  console.log("clubDetails", clubDetails);
  return axios
    .put(`${BASE_URL}/club/club_profile/`, clubDetails, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const changeClubProfilePassword = (token, passwordDetails) => {
  return axios
    .post(`${BASE_URL}/user/change_password/`, passwordDetails, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCoursesAlert = (token) => {
  return axios
    .get(`${BASE_URL}/club/alert_cms/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const saveCoursesAlert = (token, payload) => {
  const updated_payload = { ...payload, alert_type: payload.alert_type.id };
  delete updated_payload.status;

  console.log(updated_payload, "payload");

  return axios
    .put(`${BASE_URL}/club/alert_cms/${updated_payload.id}`, updated_payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCourseHoles = () => {
  return axios
    .get(`${BASE_URL}/club/get_course_holes/`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addCourseForLoggedInUser = (token, payLoad) => {
  return axios
    .post(`${BASE_URL}/club/course/`, payLoad, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getClubDetailForLoggedInUser = (token) => {
  return axios
    .get(`${BASE_URL}/club/club_profile/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const deleteUserAccount = (token) => {
  return axios.delete(`${BASE_URL}/user/`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

